module.exports = __webpack_public_path__ + "static/media/customerService1.0eb084a7.png";